import { render, staticRenderFns } from "./LayoutDialog.vue?vue&type=template&id=736a1f14&"
import script from "./LayoutDialog.vue?vue&type=script&lang=js&"
export * from "./LayoutDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports